import { getEmailDetails } from './states';

export const services = {
  getEmailDetails: getEmailDetails,
};
